<script>
  // @ts-check
  import { createEventDispatcher } from "svelte";
  import { cubicInOut } from "svelte/easing";
  import { fade, fly } from "svelte/transition";

  import { getTheme } from "../../utilities/themes";

  /** @type {import('../../utilities/themes.js').ThemeName} */
  export let theme = "white";

  /** @type {boolean} */
  export let isSearchPanelVisible = false;

  /** @type {boolean} */
  export let isMobile = false;

  export let collapseDisplayedSectionOnSearch = false;

  /** @type {import('../../utilities/themes').Theme}*/
  $: currentDesktopTheme = getTheme(theme);

  let screenHeight = 0;

  const dispatch = createEventDispatcher();
</script>

<svelte:window bind:innerHeight={screenHeight} />
<div
  in:fly={{
    duration: 600,
    delay: 0,
    y: isMobile && !isSearchPanelVisible ? -screenHeight : "-100%",
    easing: cubicInOut,
    opacity: 1
  }}
  out:fly={{
    duration: collapseDisplayedSectionOnSearch ? (isMobile ? 300 : 150) : 600,
    delay: collapseDisplayedSectionOnSearch ? (isMobile ? 300 : 150) : 300,
    y: isMobile && !isSearchPanelVisible ? -screenHeight : "-100%",
    easing: cubicInOut,
    opacity: 1
  }}
  on:introend={() => dispatch("introEnd")}
  class="{currentDesktopTheme?.backgroundColor} transition-color z-11 absolute left-0 top-0 w-full {isSearchPanelVisible
    ? 'pt-nav-height-mobile'
    : ''} lg:pt-nav-height-desktop"
>
  <div
    in:fade|global={{
      duration: 300,
      delay: collapseDisplayedSectionOnSearch ? (isMobile ? 600 : 300) : isMobile ? 300 : 450,
      easing: cubicInOut
    }}
    out:fade|global={{ duration: 300, easing: cubicInOut }}
  >
    <slot name="content" />
  </div>
</div>
